import { Text } from "@chakra-ui/react";
import { StatesMachine } from "components/pipeline-components/classes/state-machine/state-machine";
import { DiagnosticPanel } from "./DiagnosticPanel";

export function TelefoniaEditor({
  selectedStateId,
  pipelineData,
  diagnosticUpdatePipelineData
}: {
  selectedStateId?: number;
  pipelineData?: StatesMachine;
  diagnosticUpdatePipelineData?: (
    updater: (draft: StatesMachine) => StatesMachine | void
  ) => void;
}) {
  return (
    <>
      <Text color="#90a1b9" fontWeight="600" fontSize="sm">
        Este bloco consulta a nossa API de Telefonia para enriquecer a sua base,
        buscando números de telefone válidos e atualizados associados ao CPF de
        cada lead. <br />
        <br />
        💡 Não é necessária nenhuma configuração adicional. O bloco já está
        pronto para uso e executará a busca automaticamente durante o fluxo.
      </Text>
      {selectedStateId != null &&
        pipelineData &&
        diagnosticUpdatePipelineData && (
          <DiagnosticPanel
            selectedStateId={selectedStateId}
            pipelineData={pipelineData}
            operation="TELEFONIA"
            updatePipelineData={diagnosticUpdatePipelineData}
          />
        )}
    </>
  );
}
